<template>
  <div v-title data-title="ECOP">
    <!-- 网页头部的div -->
    <div class="header">
      <div class="background"></div>
      <div class="container">
        <div class="title">
          {{isATLAS? "ATLAS":"ECOP"}}
        </div>
        <div class="h">
          {{isATLAS? "Fingerprints of Human Influence on Climate Warming":"Emergent Constraint On future Earth Projections"}}
          </div>
        <div class="hh">{{isATLAS?"":"By redefined projection period in accordance with observationally constrained global warming"}}
        </div>

      </div>
    </div>
    <div class="tabs" style="margin-top: -50px; position: relative; z-index: 9999;">
      <ul class="nav nav-tabs" v-show="liShow">
        <li class="nav-item">
          <a id='tab1' class="nav-link" :class="{ active: activeTab == 1 }" aria-current="page" href="javascript:;"
            @click="changediv(1); postData();changeIsATLAS(0)">Home</a>
        </li>
        <li class="nav-item">
          <a id='tab2' class="nav-link" :class="{ active: activeTab == 2 }" href="javascript:;"
            @click="changediv(2);changeIsATLAS(0)">Tutorial</a>
        </li>
        <li class="nav-item">
          <a id='tab3' class="nav-link" :class="{ active: activeTab == 3 }" href="javascript:;"
            @click="changediv(3);changeIsATLAS(0)">Application</a>
        </li>
        <li class="nav-item">
          <a id='tab6' class="nav-link" :class="{ active: activeTab == 6 }" href="javascript:;"
            @click="changediv(6);changeIsATLAS(1)">ATLAS</a>
        </li>
      </ul>
    </div>
    <!-- 网页主体的div -->
    <div class="bodyContainer">
      <div id='div1' v-if="activeTab === 1" class="body" style="font-family:Segoe UI; margin-top: 0px;  ">
        <!-- 按钮标题的div -->
        <div style="display: flex; justify-content: center; ">
          <div class="h2" style="font-weight: bold;">
            Select future emissions scenario and projection period to obtain redefined period:
          </div>
        </div>
        <!-- 按钮的div -->
        <div id="ele" style="display: flex; justify-content: center; margin-top: 2%;  align-items: center ;">
          <el-form style="width: 100%;" label-position="top" ref="form" :inline="true" v-model="formInline">
            <div style="display: flex; width: 100%; flex-wrap: wrap;">
              <el-form-item label="Emissions scenario:" class="my-form1">
                <el-select v-model="formInline.scenario" id="scenario" style="width: 140px; display: inline-block; "
                  class="custom-select">
                  <el-option label="SSP5-8.5" value="SSP5-8.5"></el-option>
                  <el-option label="SSP3-7.0" value="SSP3-7.0"></el-option>
                  <el-option label="SSP2-4.5" value="SSP2-4.5"></el-option>
                  <el-option label="SSP1-2.6" value="SSP1-2.6"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="Projection period:" class="my-form1">
                <el-date-picker type="year" id="startYear" class="startYear" value-format="yyyy"
                  placeholder="start year" v-model="formInline.startYear" @input="changeEndYear"
                  style="width: 150px;"></el-date-picker>
                --
                <el-input id="endyear" class="endyear" placeholder="end year" v-model="endYear" :readonly=true
                  v-on:change="changeEndYear" style="width: 120px; "></el-input>
              </el-form-item>

              <el-form-item size="small" :style="{
                marginLeft: '0px',
                display: 'flex',
                flex: 1,
                justifyContent: 'flex-end',
                alignItems: 'flex-end',
                marginBottom: '22px',
                paddingBottom: '16px'
              }">
                <el-button type="primary" @click="postData" class="my-button1">Submit</el-button>

              </el-form-item>
            </div>
            <div style="margin-top: 2%; margin-left: 5%; display: flex; justify-content: flex-end; font-size: 20px;">
              <p v-if="showError" class="error-message">{{ errorMessage }}</p>
            </div>
          </el-form>
        </div>

        <!-- 创建一个容器用于展示图表 -->
        <div class="chartScroll">
          <div class="chartContainer">
            <div id="chart" class="chart"></div>
          </div>
        </div>

        <!-- 方法div -->
        <div class="question-stem" style="margin:0 auto;text-align:justify;  padding-top: 2% ">
          <div class="h1i" style="font-weight: bold;">Method:</div>
          <ul list-style-type: none>
            <li class="li1" style="text-align: left;">Map the raw warming projections by individual models to
              observationally constrained
              projections.</li>
            <li class="li1" style="text-align: left;">Identify the model time windows in accordance with the constrained
              warming projections.</li>
            <li class="li1" style="text-align: left;">Take the Earth system projections in the identified time windows
              for impact assessments.
            </li>
          </ul>
          <div class="h1i" style="font-weight: bold;">Reference:</div>
          <p class="para-1" style="text-align: left;"><a :style="activecolor" style="text-decoration: none;"
              @mouseover="Mouseover()" @mouseleave="Mouseleave()" href="https://doi.org/10.1126/sciadv.adr5346">C. Li,
              F. W. Zwiers, X. Zhang, E. M. Fischer, F. Du, J. Liu, J. Wang, Y. Liang, T. Li, and L. Yuan, 2025:
              Constraining the entire Earth system projections for more reliable climate change adaptation planning.
              Science Advances, 11(9), eadr5346.</a></p>

        </div>

      </div>
      <div id='div2' v-if="activeTab === 2" class="body" style=" font-family:Segoe UI; margin-top: -30px; ">
        <!-- <embed id='pdf' type="application/pdf" style="width: 100%; height: 100%; margin-bottom: 40px" src='/HEC_tutorial.pdf' /> -->
        <div style="width:100%;font-family: Segoe UI">
          <p style="text-align: left; font-size: 22px;font-weight: bold;">Using constrained warming levels to constrain
            future Earth projections</p>

          <p style="text-align: left; font-size: 20px; margin-bottom:0">Given a set of simulated warming
            trends for the
            historical period 1981-2020 and projected warming rates for a scenario specific future period relative to
            preindustrial 1850-1900 from an ensemble of Earth system models, a <a :style="activecolor"
              @mouseover="Mouseover()" @mouseleave="Mouseleave()" @click="changediv(4); changeLiShow()"
              style="cursor: pointer;">hierarchical emergent constraint
              method</a>
            <!-- @click="downloadFile('HEC_tutorial.pdf', 'HEC_tutorial.pdf')"  -->
            <!-- <div class="tooltip" v-if="showTooltip">
                <p>This is a tooltip!</p>
              </div> -->
            is employed to obtain a distribution for future warming that is constrained by observed warming as
            follows:
          </p>
          <br>
          <div class="scrolldiv">
            <math xmlns="http://www.w3.org/1998/Math/MathML" display="block"
              style="font-family:'Times New Roman', Times, serif;">
              <msub>
                <mi>p</mi>
                <mrow>
                  <mn>2</mn>
                </mrow>
              </msub>
              <mrow data-mjx-texclass="INNER">
                <mo data-mjx-texclass="OPEN">(</mo>
                <mtable columnspacing="1em" rowspacing="4pt">
                  <mtr>
                    <mtd>
                      <msub>
                        <mi>&#x3BC;</mi>
                        <mrow>
                          <mi>F</mi>
                        </mrow>
                      </msub>
                      <mo>+</mo>
                      <mfrac>
                        <mrow>
                          <mi>&#x3C1;</mi>
                          <msub>
                            <mi>&#x3C3;</mi>
                            <mrow>
                              <mi>F</mi>
                            </mrow>
                          </msub>
                          <msub>
                            <mi>&#x3C3;</mi>
                            <mrow>
                              <mi>H</mi>
                            </mrow>
                          </msub>
                        </mrow>
                        <mrow>
                          <msubsup>
                            <mi>&#x3C3;</mi>
                            <mrow>
                              <mi>H</mi>
                            </mrow>
                            <mrow>
                              <mn>2</mn>
                            </mrow>
                          </msubsup>
                          <mo>+</mo>
                          <msubsup>
                            <mi>&#x3C3;</mi>
                            <mrow>
                              <mi>H</mi>
                              <mi mathvariant="normal">_</mi>
                              <mi>o</mi>
                              <mi>b</mi>
                              <mi>s</mi>
                            </mrow>
                            <mrow>
                              <mn>2</mn>
                            </mrow>
                          </msubsup>
                        </mrow>
                      </mfrac>
                      <mrow data-mjx-texclass="INNER">
                        <mo data-mjx-texclass="OPEN">(</mo>
                        <msub>
                          <mi>&#x3BC;</mi>
                          <mrow>
                            <mi>H</mi>
                            <mi mathvariant="normal">_</mi>
                            <mi>o</mi>
                            <mi>b</mi>
                            <mi>s</mi>
                          </mrow>
                        </msub>
                        <mo>&#x2212;</mo>
                        <msub>
                          <mi>&#x3BC;</mi>
                          <mrow>
                            <mi>H</mi>
                          </mrow>
                        </msub>
                        <mo data-mjx-texclass="CLOSE">)</mo>
                      </mrow>
                      <mo>,</mo>
                      <msubsup>
                        <mi>&#x3C3;</mi>
                        <mrow>
                          <mi>F</mi>
                        </mrow>
                        <mrow>
                          <mn>2</mn>
                        </mrow>
                      </msubsup>
                      <mrow data-mjx-texclass="INNER">
                        <mo data-mjx-texclass="OPEN">(</mo>
                        <mn>1</mn>
                        <mo>&#x2212;</mo>
                        <mfrac>
                          <msup>
                            <mi>&#x3C1;</mi>
                            <mrow>
                              <mn>2</mn>
                            </mrow>
                          </msup>
                          <mrow>
                            <mn>1</mn>
                            <mo>+</mo>
                            <msubsup>
                              <mi>&#x3C3;</mi>
                              <mrow>
                                <mi>H</mi>
                                <mi mathvariant="normal">_</mi>
                                <mi>o</mi>
                                <mi>b</mi>
                                <mi>s</mi>
                              </mrow>
                              <mrow>
                                <mn>2</mn>
                              </mrow>
                            </msubsup>
                            <mrow>
                              <mo>/</mo>
                            </mrow>
                            <msubsup>
                              <mi>&#x3C3;</mi>
                              <mrow>
                                <mi>H</mi>
                              </mrow>
                              <mrow>
                                <mn>2</mn>
                              </mrow>
                            </msubsup>
                          </mrow>
                        </mfrac>
                        <mo data-mjx-texclass="CLOSE">)</mo>
                      </mrow>
                    </mtd>
                  </mtr>
                </mtable>
                <mo data-mjx-texclass="CLOSE">)</mo>
              </mrow>
            </math>
          </div>
          <br>
          <p style="text-align: left; font-size:20px; margin-bottom:30px;">where
            <i>p</i><sub>2</sub>(∙)denotes the normal
            cumulative
            distribution function with mean and variance given by the two terms in the outer brackets, <i>ρ</i> is the
            correlation between the historical warming trends and future warming rates in Earth system models,
            <i>μ</i><sub>F</sub> and
            <i>σ</i><sub>F</sub> are the ensemble mean and standard deviation of the projected future warming rates,
            <i>μ</i><sub>H</sub> and <i>σ</i><sub>H</sub>
            are the corresponding values of the simulated historical warming trends, and <i>μ</i><sub>H_obs</sub> and
            <i>σ</i><sub>H_obs</sub> denote
            the observed warming trend and associated internal warming variability.
          </p>
          <p style="text-align: left; font-size: 20px;margin-bottom:0;">Denoting the cumulative
            distribution function
            for the unconstrained raw warming projections by <i>p</i><sub>1</sub>(<i>μ</i><sub>F</sub>
            ,<i>σ</i><sub>F</sub><sup style="margin-left:-5px">2</sup>), the raw warming projections are
            converted to a set of constrained projections conforming to the distribution <i>p</i><sub>2</sub> by
            <a :style="activecolor" @mouseover="Mouseover()" @mouseleave="Mouseleave()"
              @click="changediv(5); changeLiShow()" style="cursor: pointer;">quantile
              mapping</a>:
          </p>
          <br>
          <div class="scrolldiv">
            <math xmlns="http://www.w3.org/1998/Math/MathML" display="block"
              style="font-family: 'Times New Roman', Times, serif;">
              <mi>&#x3B4;</mi>
              <msub>
                <mi>T</mi>
                <mrow>
                  <mi>i</mi>
                </mrow>
              </msub>
              <mo accent="false" stretchy="false">&#x2192;</mo>
              <msubsup>
                <mi>p</mi>
                <mrow>
                  <mn>2</mn>
                </mrow>
                <mrow>
                  <mo>&#x2212;</mo>
                  <mn>1</mn>
                </mrow>
              </msubsup>
              <mrow data-mjx-texclass="INNER">
                <mo data-mjx-texclass="OPEN">(</mo>
                <msub>
                  <mi>p</mi>
                  <mrow>
                    <mn>1</mn>
                  </mrow>
                </msub>
                <mrow data-mjx-texclass="INNER">
                  <mo data-mjx-texclass="OPEN">(</mo>
                  <mi>&#x3B4;</mi>
                  <msub>
                    <mi>T</mi>
                    <mrow>
                      <mi>i</mi>
                    </mrow>
                  </msub>
                  <mo data-mjx-texclass="CLOSE">)</mo>
                </mrow>
                <mo data-mjx-texclass="CLOSE">)</mo>
              </mrow>
            </math>
          </div>
          <br>
          <p style="text-align:left; font-size: 20px; margin-bottom:25px;">where <i>δT</i><sub>i</sub> is the
            projected warming
            by model <i>i</i>
            and <i>p</i><sub>2</sub><sup style="margin-left:-5px">-1</sup>(∙) is the inverse (quantile) function of
            <i>p</i><sub>2</sub>(∙). Model time windows when models warm to
            their corresponding constrained warming projections can be identified from their raw output. Simulations of
            the Earth system in the identified time windows are the observed warming-constrained
            projections for the period of interest, and can be used to assess climate change impacts from
            different dimensions.
          </p>
        </div>

        <!-- @click="downloadFile('code.txt')" -->
        <!-- <pre style="margin-top: 20px; background-color: blanchedalmond;">
      HECr <- function(obs, sigma.obs, xh.model, xf.model, alpha=0.1) {
      # HECr returns observation-constrained climate projections by HEC
      # obs : an observation of the current climate state
      # sigma.obs : uncertainty measure of the observation by standard deviation
      # xh.model : model estimates of historical climate
      # xf.model : model estimates of future climate
      # alpha : (1-alpha) central uncertainty range of constrained future climate
      #
      # = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = = =

      if (length(xh.model) != length(xf.model)) stop('HECr: xh.model and xf.model dimension mismatch.')

      obs <- as.vector(obs)
      xh.model <- as.vector(xh.model)
      xf.model <- as.vector(xf.model)

      mu.xh <- mean(xh.model, na.rm=T)
      mu.xf <- mean(xf.model, na.rm=T)

      sigma.xh <- sd(xh.model, na.rm=T)
      sigma.xf <- sd(xf.model, na.rm=T)

      rho <- cor(xh.model, xf.model, use='complete.obs')

      mu.hec <- mu.xf+(rho*sigma.xh*sigma.xf)/(sigma.xh^2+sigma.obs^2)*(obs-mu.xh)
      sigma.hec <- (sigma.xf^2)*(1-rho^2/(1+sigma.obs^2/sigma.xh^2))
      sd.hec <- sqrt(sigma.hec)

      xf.hec <- mu.hec
      ci.hec.low <- qnorm(alpha/2, mean=mu.hec, sd=sd.hec)
      ci.hec.up <- qnorm(1-alpha/2, mean=mu.hec, sd=sd.hec)
      ci.hec <- cbind(ci.hec.low, ci.hec.up)

      return(list(xf.hec=xf.hec, ci.hec=ci.hec, mu.hec=mu.hec, sd.hec=sd.hec))
      }
        </pre> -->
      </div>
      <div id='div3' v-if="activeTab === 3" class="body" style=" font-family:Segoe UI; margin-top: -30px; ">
        <div>
          <!-- 创建一个容器用于展示图表 -->
          <div style='text-align: left;'>
            <div><strong>Time when future 5-year TXx events become hotter than the rare 50-year events in
                1951-2020</strong></div>

            <div id="ele1"
              style="display: flex; justify-content: center; margin-top: 2%; margin-bottom: -20px; align-items: center ;">
              <el-form style="width: 100%;" label-position="top" ref="form" :inline="true" v-model="formInline">
                <div style="display: flex; width: 100%; flex-wrap: wrap; ">
                  <el-form-item label="Emissions scenario:" class="my-form1 is-fill">
                    <el-select @change="selectOne" v-model="formInline5" id="scenario1"
                      style="width: 100%; display: inline-block; " class="custom-select">
                      <el-option label="SSP5-8.5" value="55"></el-option>
                      <el-option label="SSP2-4.5" value="52"></el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </el-form>
            </div>

            <div class="chartScroll" :style="{ height: (width > 700 ? '550px' : '370px') }"
              style=" border-top-width: 0px; overflow:hidden">
              <!-- <div class="chartContainer"> -->
              <iframe id='5iframe' :style="{ height: (width > 700 ? '540px' : '360px') }"
                style="width: 900px; margin-bottom: 0px; " src='/geo52.html'></iframe>
              <!-- <iframe id='5iframe' style="width: 100%; height: 400px; margin-bottom: 0px; " src='/geo52.html'></iframe>  -->
              <!-- </div> -->
            </div>
          </div>
          <div style='text-align: left; margin-top: 50px;'>
            <div><strong>Time when future 2-year TXx events become hotter than the rare 50-year events in
                1951-2020</strong></div>
            <div id="ele2"
              style="display: flex; justify-content: center; margin-top: 2%; margin-bottom: -20px; align-items: center ;">
              <el-form style="width: 100%;" label-position="top" ref="form" :inline="true" v-model="formInline">
                <div style="display: flex; width: 100%; flex-wrap: wrap; ">
                  <el-form-item label="Emissions scenario:" class="my-form1 is-fill">
                    <el-select @change="selectOne" v-model="formInline2" id="scenario2"
                      style="width: 100%; display: inline-block; " class="custom-select">
                      <el-option label="SSP5-8.5" value="25"></el-option>
                      <el-option label="SSP2-4.5" value="22"></el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </el-form>
            </div>
            <div class="chartScroll" :style="{ height: (width > 700 ? '550px' : '370px') }"
              style=" border-top-width: 0px;overflow:hidden">
              <!-- <div class="chartContainer"> -->
              <iframe id='2iframe' :style="{ height: (width > 700 ? '540px' : '360px') }"
                style="width: 900px; margin-bottom: 0px" src='/geo22.html'></iframe>
              <!-- <iframe id='2iframe' style="width: 100%; height: 400px; margin-bottom: 0px" src='/geo22.html'></iframe> -->
              <!-- </div> -->
            </div>
          </div>

        </div>
      </div>
      <div id='div4' v-if="activeTab === 4" class="body" style=" font-family:Segoe UI; margin-top: 30px; ">
        <div style="height: 4vh; cursor: pointer;" @click="changediv(2); changeLiShow()">
          <p :style="activecolor" @mouseover="Mouseover()" @mouseleave="Mouseleave()"
            style="font-size: 2vh; float: left;text-decoration: underline;">Back to Tutorial</p>
        </div>
        <paper />
      </div>
      <div id='div5' v-if="activeTab === 5" class="body" style=" font-family:Segoe UI; margin-top: 30px; ">
        <div style="height: 4vh; cursor: pointer;" @click="changediv(2); changeLiShow()">
          <!-- <img src="/return.png" style="height: 2vh; float: left;"> -->
          <p :style="activecolor" @mouseover="Mouseover()" @mouseleave="Mouseleave()"
            style="font-size: 2vh; float: left;text-decoration: underline;">Back to Tutorial</p>
        </div>
        <br>
        <div class="scrolldiv" style="text-align:center">
          <p class="font5" style="text-align:center; "><strong style="font-weight: bold;">
              A schematic illustration of quantile mapping
            </strong>
          </p>
        </div>
        <br>
        <div class="scrolldiv" style="text-align:center">
          <img id="mapping" style="width: 100%;max-width: 700px" src="mapping.jpg">
        </div>
        <div class="scrolldiv" style="text-align:center;height: 100px">

        </div>
      </div>
      <div id='div6' v-if="activeTab === 6" class="body" style=" font-family:Segoe UI;">
        <Temperature />
      </div>
    </div>
    <!-- 网页尾部的div -->
    <div class="footer">
      <div class="footerContainer">
        <div class="title" style="font-weight: bold;">ECOP</div>
        <div class="h">
          Emergent Constraint On future Earth Projections</div>
        <div class="line3"><a style="font-weight: bold;">Contact:</a> Chao Li (cli at geo.ecnu.edu.cn) - East China
          Normal University - Shanghai, China <br>
          <a style="font-weight: bold;">Funders:</a> National Key R&D Program of China (2020YFA0208901) and National
          Nature Science Foundation of China (42075026)
        </div>
        <!-- <div class="line3">Funded by:</div>
          <ul list-style-type: none>
            <li class="line3">National Key R&D Program of China. Grant Number: 2020YFA0208901</li>
            <li class="line3">National Nature Science Foundation of China. Grant Number: 42075026</li>
          </ul> -->
        <br>
        <div class="line4">Page visits: {{ visitNum }}</div>

      </div>
    </div>

  </div>
</template>
<script>
import { validateInput, showError } from './validateInput.js'     //引用模块进来
import paper from './paper.vue';
import Temperature from './Temperature.vue';
import { updateChart } from './updateChart.js'
import axios from 'axios'
import TheLatex2Math from './gs.vue'
import $ from 'jquery'

export default {
  components: {
    TheLatex2Math,
    paper,
    Temperature
  },
  data() {
    return {
      // showTooltip: false,
      isATLAS:false,
      buttonID: 0,
      buttonStyle: true,
      liShow: true,
      activecolor: "color: #3675aa",
      width: document.body.clientWidth,
      gs: 'p_{\\text{2}}()',
      question2: 'p_{\\text{2}}\\left( {\\mu_{\\text{F}} + \\frac{\\rho\\sigma_{\\text{F}}\\sigma_{H}}{\\sigma_{\\text{H}}^{2} + \\sigma_{\\text{H_obs}}^{2}}\\left( {\\mu_{\\text{H_obs}} - \\mu_{\\text{H}}} \\right),\\sigma_{\\text{F}}^{2}\\left( {1 - \\frac{\\rho^{2}}{1 + {\\sigma_{\\text{H_obs}}^{2}/\\sigma_{\\text{H}}^{2}}}} \\right)} \\right)',
      question3: '\\rho',
      question4: '\\mu_{\\text{F}}',
      question5: '\\sigma_{\\text{H}}',
      question6: 'p_{\\text{1}}\\left( {\\mu_{\\text{F}},\\sigma_{\\text{F}}^{2}} \\right)',
      question7: '\\left. \\delta T_{i}\\rightarrow p_{2}^{- 1}\\left( {p_{1}\\left( {\\delta T_{i}} \\right)} \\right) \\right.',
      endYear: '2059',
      formInline: {
        scenario: 'SSP5-8.5',
        startYear: '2040',
      },
      formInline5: {

      },
      formInline2: {

      },
      activeTab: 1,
      showError: false, // 控制是否显示错误信息
      errorMessage: '', // 错误信息内容
      visitNum: 0,
    };
  },
  //在页面创建的时候调用methods中的formatMath的方法
  created() {
    this.formatMath();
  },
   watch: {
    '$route'(to) {
      if (to.query.tab === '6') {
        this.activeTab = 6;
        this.isATLAS = true;
      }
    }
  },
  mounted() {
     if (this.$route.query.tab === '6') {
      this.activeTab = 6;
      this.isATLAS = true;
    }
    this.postData();
    axios.get("https://www.ecop-earth.com/add_visits")
    axios.get("https://www.ecop-earth.com/get_visits").then((result) => {
      this.visitNum = result.data
    });
    var w = document.body.clientWidth;
    if (w > 700) {
      document.getElementById("mapping").style.width = "700px"
    }
  },

  methods: {

    changeIsATLAS(item){
      if(item==0){
        this.isATLAS=false
      }else{
        this.isATLAS=true
      }
       
    },
    Mouseover() {
      // console.log("进入 悬停区域");
      this.activecolor = "color:#78aad1"; // 进入 悬停区域,更改文字颜色
      // this.showTooltip=true;
    },

    // 鼠标"离开"触发此方法
    Mouseleave() {
      // console.log("离开 悬停区域");
      this.activecolor = "color: #3675aa"; // 离开 悬停区域,文字颜色复原
      // this.showTooltip=false;
    },
    buttonMouseover(e) {
      this.buttonStyle = false;
      var id = e.currentTarget.id;
      if (id == "button41") {
        this.buttonID = 1;
      } else if (id == "button42") {
        this.buttonID = 2;
      } else if (id == "button43") {
        this.buttonID = 3;
      } else {
        this.buttonID = 4;
      }
    },
    buttonMouseleave() {
      this.buttonStyle = true;
      this.buttonID = 0;
    },
    changeLiShow() {
      this.liShow = !this.liShow;
    },
    downloadFile(url, fileName) {
      const fileUrl = url; // 文件的URL地址
      const link = document.createElement('a');
      link.href = fileUrl;
      link.setAttribute('download', fileName);
      link.click();
    },
    selectOne(item) {     //change 触发事件
      // console.log(item[0]+'iframe')
      // console.log('src','/geo'+item+'.html')
      $('#' + item[0] + 'iframe').attr('src', '/geo' + item + '.html');
    },
    changediv(idx) {
      this.activeTab = idx
    },

    formatMath() {
      setTimeout(() => {
        this.$nextTick(() => {
          if (this.MathJax.isMathjaxConfig) {
            this.MathJax.initMathjaxConfig();
          }
          //这个地方的hello是对应要渲染数学公式的dom的class
          this.MathJax.MathQueue('question-stem');
        })
      }, 500)
    },

    changeEndYear() {
      if (this.formInline.startYear) {
        this.endYear = parseInt(this.formInline.startYear) + 19;
      } else {
        this.endYear = '';
      }
    },
    postData() {
      const { scenario, startYear } = this.formInline;
      const inputParams = validateInput(scenario, startYear);
      if (inputParams.isValid) {
        // 定义要发送的数据
        const data = {
          proj_scenario: inputParams.scenario,
          proj_period: [parseInt(inputParams.startYear), parseInt(inputParams.startYear) + 20]
        };

        // axios.post('https://www.ecop-earth.com/get_xy1', data,{
        axios.post('https://www.ecop-earth.com/get_xy1', data, {
          // axios.post('http://127.0.0.1:5000/get_xy1', data, {
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(data)
        })
          .then(response => {
            // 解析响应数据为 JSON 格式
            const responseData = response.data;
            console.log('响应数据:', responseData);
            // 更新图表数据
            updateChart(responseData);
            // 请求成功后重置错误状态
            this.showError = false;
          })
          .catch(error => {
            console.error('请求错误:', error);
            // 请求发生错误时设置错误状态，并显示错误信息
            this.showError = true;
            this.errorMessage = 'The start year should be between 1850 to 2078';
          });
      }
    },
  }
};
</script>


<style lang="less" scoped>
/* 隐藏鼠标点击这些元素时出现的光标 */
div,
span,
p {
  caret-color: transparent;
}

.nav-link {
  font-size: 20px;
  height: 45px;
  color: rgb(255, 255, 255);
  border-width: 3px !important;
}


.nav-tabs {
  border-bottom: none;
  display: flex;
  flex-wrap: nowrap;
}

.nav-item {
  display: flex;
  flex: 1 0 auto;
  max-width: 150px;
  text-align: center;
}

.font1 {
  font-size: 18px;
  line-height: 30px;
}

.font2 {
  font-size: 20px;
}

.font3 {
  font-size: 18px;
}

.font4 {
  font-size: 28px;
}

.font5 {
  font-size: 24px;
}


.tabs {
  display: flex;
  justify-content: center;
  margin-top: 40px;
  font-size: 25px;
}

.header {
  color: rgb(209, 217, 229);
  overflow: hidden;
  padding-bottom: 38px;
  padding: 10px 32px 56px;
  overflow: hidden;
  position: relative;
  background: url('../../assets/wave.jpg');
  background-size: cover;
  background-position: center;
  display: flex;
  justify-content: center;

  .background {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    filter: blur(20px);
    z-index: 0;
    background: url('../../assets/wave.jpg');
    background-size: cover;
    background-position: center;
  }

  .container {
    margin-bottom: 0px;
    z-index: 1;
    position: relative;
    max-width: 900px;
    width: calc(100vw - 64px);

    .title {
      font-size: 88px;
      font-weight: 700;
    }

    .h {
      font-size: 28px;
      margin-top: -15px;
      font-weight: 500;
    }

    .hh {
      margin-top: 0px;
      margin-bottom: 25px;
      font-size: 20px;
    }
  }
}

.bodyContainer {
  display: flex;
  justify-content: center;

  .body {
    max-width: 900px;
    // width:80vw;
    width: calc(100vw - 64px);
    display: flex;
    flex-direction: column;
    padding: 48px 0;
    font-size: 20px;

    .h2 {
      color: #222121;
      width: 100%;
      font-size: 20px;
      margin-top: -30px;
    }

    .chartScroll {
      width: 100%;
      overflow: auto;
      position: relative;
      border-top: solid 1px black;
      border-bottom: solid 1px black;
      // height: 450px;
      // height:550px;
      display: flex;
      align-items: center;
      justify-items: center;
      // overflow-x: hidden;
    }

    .chartContainer {
      height: 420px;
      width: 876px;
      // width:100%;
      padding-top: 24px;
      position: relative;

      .chart {
        margin: 0 auto;
        width: 1460px;
        // width:100%;
        height: 700px;
        // height: fit-content;
        transform: scale(.60);
        left: -280px;
        top: -152px;
      }
    }
  }
}

.question-stem {
  width: 100%;
}


.para-1 {
  width: 100%;
  margin: auto;
  text-align: justify;
  color: #222121;
  margin-top: 12px;
  padding-left: 20px;
  font-size: 18px;
  margin-bottom: 14px;
}

.para-2 {
  width: 100%;
  margin: auto;
  text-align: justify;
  text-indent: 2em;
  color: #222121;
}

ul {
  margin: 8px 0;
}

.li1 {
  display: list-item;
  width: 100%;
  margin: auto;
  text-align: justify;
  color: #222121;
  padding-bottom: 6px;
  font-size: 18px;
}


.my-form1 {
  margin-top: 16px;

  &.el-form-item {
    margin-right: 24px;
    background: #edf0f6;
    border-radius: 8px;
    padding: 32px 18px 18px;
    position: relative;
    box-shadow: 0 0 2px #8990a5;

    &.is-fill {
      width: 100%;
    }
  }

  /deep/.el-form-item__label {
    font-size: 14px;
    line-height: 20px;
    margin-bottom: 8px;
    position: absolute;
    border-radius: 4px;
    border: solid 1px #8990a5;
    top: -14px;
    left: 8px;
    background-color: #4381a9;
    padding: 8px;
    line-height: 14px;
    color: #fff;
  }

  /deep/.el-form-item__content {
    * {
      text-align: center;
    }
  }
}

/deep/.my-button1 {
  text-align: center;
  color: #fff !important;
  background-color: #296388 !important;
  // border: 1px solid #0d0d0d !important;
  font-size: 18px;
}

.footer {
  color: #fff;
  background-color: rgb(10 23 38);
  display: flex;
  justify-content: center;
  align-items: flex-end;

  .footerContainer {
    max-width: 900px;
    width: calc(100vw - 64px);
    padding: 24px 24px 44px;
  }

  .title {
    font-size: 28px;
  }

  .h {
    margin-top: 8px;
    font-size: 18px;
  }

  .line3 {
    font-size: 12px;
    margin-top: 20px;
    color: #8990a5;
  }

  .line4 {
    font-size: 12px;
    margin-top: 4px;
    color: #8990a5;
  }
}


.custom-select /deep/ .el-input__inner {
  color: #0c0c0c !important;
  border: 1px solid #0d0d0d;
}

.startYear /deep/ .el-input__inner {
  color: #0c0c0c !important;
  border: 1px solid #0d0d0d;
}

.endyear /deep/ .el-input__inner {
  color: #0c0c0c !important;
  border: 1px solid #0d0d0d;
}

.el-divider /deep/ {
  background-color: #0c0c0c !important;
  height: 2px !important;
}

#chart {
  background-color: #fcfefe;
}


.scrolldiv {
  width: 100%;
  text-align: center;
  overflow-x: scroll;
  -ms-overflow-style: none;
  // overflow: -moz-hidden-unscrollable;
  white-space: nowrap
}

.scrolldiv::-webkit-scrollbar {
  display: none;
}

.buttonOverStyle {
  background-color: white;
  border: 2px solid #4381a9;
  color: #4381a9;

}

.buttonLeaveStyle {
  background-color: #4381a9;
  border: 2px solid white;
  color: white
}
</style>